import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import { isMobile } from 'react-device-detect';
import gamesData from '../games.json';

const GamesGridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 20px;
  padding: 20px;
`;

const GameItem = styled.div`
  cursor: pointer;
  text-align: center;
  padding: 30px;
`;

const GameIcon = styled.img`
  width: 100%;
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.2);
  }
`;

const GameName = styled.div`
  margin-top: 30px;
  font-family: 'Arcade', sans-serif;
`;

const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "grey", borderRadius: "50%", zIndex: 25 }}
      onClick={onClick}
    />
  );
};

const CustomPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "grey", borderRadius: "50%", zIndex: 25 }}
      onClick={onClick}
    />
  );
};

const GamesCarousel = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    setCategories(gamesData);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 5,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />
  };

  const handleClick = (url) => {
    window.location.href = url;
  };

return (
  <div>
    {categories.map(category => {
      const target = isMobile ? 2 : 6;
      const fillers = Math.max(0, target - category.games.length);

      return (
        <div
          key={category.category}
          style={{ width: (isMobile ? "60%" : "80%"), margin: "auto" }}
        >
          <Slider {...settings}>
            {category.games.map(game => (
              <div key={game.name}>
                <GameItem onClick={() => handleClick(game.url)}>
                  <GameIcon
                    src={process.env.PUBLIC_URL + game.imageUrl + "icon.png"}
                    alt={game.name}
                  />
                  <GameName><b>{game.name}</b></GameName>
                </GameItem>
              </div>
            ))}

            {[...Array(fillers)].map((_, index) => (
              <div key={`filler-${index}`}>
                <GameItem onClick={() => handleClick("#")}>
                  <GameIcon
                    src={process.env.PUBLIC_URL + category.defaultImage}
                    alt="Coming Soon"
                  />
                  <GameName>Coming Soon</GameName>
                </GameItem>
              </div>
            ))}
          </Slider>
        </div>
      );
    })}
  </div>
);
};

export default GamesCarousel;